module.exports = __webpack_public_path__ + "static/img/picture1.9b23c4fd.png";